module.exports = __webpack_public_path__ + "static/media/kundenstamm.7cf481ee.mp4";